// extracted by mini-css-extract-plugin
module.exports = {"icon":"main_icon__35dvU","content":"main_content__3MZZw"};